import { themeVariables } from "Components/theme";
import { GraphEditorInputMode, IEdge, INode, PolylineEdgeStyle, Rect, WebGL2GraphModelManager } from "yfiles";
import buildStroke from "./buildStroke";
export default class RenderingManager {
    constructor(graphComponent, webGL2NodeStyleProvider, webGL2EdgeStyleProvider, nodeCreator = null) {
        this.graphComponent = graphComponent;
        this.webGL2NodeStyleProvider = webGL2NodeStyleProvider;
        this.webGL2EdgeStyleProvider = webGL2EdgeStyleProvider;
        this.nodeCreator = nodeCreator;
        this.graphComponent.focusIndicatorManager.enabled = false;
        this.graphComponent.graphModelManager = new WebGL2GraphModelManager({ renderMode: "web-gl" });
        this.graphComponent.graph.decorator.nodeDecorator.reshapeHandlerDecorator.hideImplementation();
        this.graphComponent.graph.decorator.edgeDecorator.edgePortHandleProviderDecorator.hideImplementation();
    }
    registerListeners() {
        this.graphComponent.selection.addItemSelectionChangedListener((_, evt) => {
            if (evt.item instanceof INode) {
                this.setWebGL2NodeStyle(evt.item, evt.itemSelected, true);
            }
            if (evt.item instanceof IEdge) {
                this.setWebGL2PolylineEdgeStyle(evt.item, evt.itemSelected, true);
            }
        });
        if (!(this.graphComponent.inputMode instanceof GraphEditorInputMode)) {
            return;
        }
        this.graphComponent.inputMode.addNodeCreatedListener((_, evt) => {
            this.setWebGL2NodeStyle(evt.item, false, false);
        });
        this.graphComponent.inputMode.createEdgeInputMode.addEdgeCreatedListener((_, evt) => {
            this.setWebGL2PolylineEdgeStyle(evt.item, false, false);
        });
        const edgeInCreationProcessCallback = () => {
            if (!(this.graphComponent.inputMode instanceof GraphEditorInputMode &&
                this.graphComponent.inputMode.createEdgeInputMode))
                return;
            const polylineEdgeStyle = this.graphComponent.inputMode.createEdgeInputMode.dummyEdge.style;
            if (polylineEdgeStyle instanceof PolylineEdgeStyle) {
                polylineEdgeStyle.stroke = buildStroke(themeVariables["gray-500"], false);
            }
        };
        this.graphComponent.inputMode.createEdgeInputMode.addGestureStartedListener(edgeInCreationProcessCallback);
        this.graphComponent.inputMode.createEdgeInputMode.addEdgeCreationStartedListener(edgeInCreationProcessCallback);
        if (this.nodeCreator) {
            this.graphComponent.inputMode.nodeCreator = this.nodeCreator;
        }
    }
    setWebGL2Styles(updateNodeLayouts) {
        const { graph, selection } = this.graphComponent;
        for (const node of graph.nodes) {
            this.setWebGL2NodeStyle(node, selection.selectedNodes.includes(node), false, updateNodeLayouts);
        }
        for (const edge of graph.edges) {
            this.setWebGL2PolylineEdgeStyle(edge, selection.selectedEdges.includes(edge), false);
        }
    }
    setWebGL2NodeStyle(node, selected, checkGraphContains, updateNodeLayout) {
        if (checkGraphContains && !this.graphComponent.graph.contains(node))
            return undefined;
        const style = this.webGL2NodeStyleProvider(node, selected, this.graphComponent.graph);
        if (!style)
            console.warn("Error while getting style for node:", node.tag);
        style &&
            this.graphComponent.graphModelManager.setStyle(node, style);
        if (updateNodeLayout)
            this.graphComponent.graph.setNodeLayout(node, new Rect(node.layout.x, node.layout.y, style.icon.width, style.icon.height));
        return style;
    }
    setWebGL2PolylineEdgeStyle(edge, selected, checkGraphContains) {
        if (checkGraphContains && !this.graphComponent.graph.contains(edge))
            return undefined;
        const style = this.webGL2EdgeStyleProvider(edge, selected, this.graphComponent.graph);
        if (!style)
            console.warn("Error while getting style for edge:", edge.tag);
        style &&
            this.graphComponent.graphModelManager.setStyle(edge, style);
        return style;
    }
}
